(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-equipment-request-price"]) return;
  try {
    
  document.querySelectorAll('[data-csc-request-price]').forEach((root) => {
    const form = root.querySelector('[data-csc-rfp-form]');
    const status = root.querySelector('[data-csc-rfp-status]');
    const submit = root.querySelector('[data-csc-rfp-submit]');
    const submitLabel = root.querySelector('[data-csc-submit-label]');
    const requestId = root.querySelector('[data-csc-request-id]');
    const variantId = root.querySelector('[data-csc-variant-id]');
    const variantSelect = root.querySelector('[data-csc-variant-select]');
    const weight = root.querySelector('[data-csc-weight]');
    const customerType = root.querySelector('[data-csc-customer-type]');
    const companyField = root.querySelector('[data-csc-company]');
    const companyInput = companyField.querySelector('input');
    const steps = Array.from(root.querySelectorAll('[data-csc-rfp-step]'));
    const indicators = Array.from(root.querySelectorAll('[data-csc-step-indicator]'));
    const next = root.querySelector('[data-csc-rfp-next]');
    const back = root.querySelector('[data-csc-rfp-back]');
    const originalSubmitLabel = submitLabel.textContent;

    const resetRequestId = () => { requestId.value = crypto.randomUUID(); };
    const updateCompany = () => {
      const isBusiness = customerType.value === 'business';
      companyField.hidden = !isBusiness;
      companyInput.required = isBusiness;
      if (!isBusiness) companyInput.value = '';
    };
    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.selectedOptions[0];
      variantId.value = option.value;
      weight.textContent = option.dataset.weight;
    };
    const showStep = (number, focusHeading = true) => {
      steps.forEach((step) => { step.hidden = step.dataset.cscRfpStep !== String(number); });
      indicators.forEach((indicator) => {
        if (indicator.dataset.cscStepIndicator === String(number)) {
          indicator.setAttribute('aria-current', 'step');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
      if (focusHeading) steps[number - 1].querySelector('[data-csc-step-heading]')?.focus();
    };
    const validateStep = (step) => {
      const invalid = Array.from(step.querySelectorAll('input, select, textarea')).find((field) => !field.checkValidity());
      if (!invalid) return true;
      invalid.reportValidity();
      invalid.focus();
      return false;
    };
    const clearErrors = () => {
      form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
      form.querySelectorAll('[data-error-for]').forEach((error) => { error.textContent = ''; });
      status.textContent = '';
    };
    const showFieldErrors = (fields) => {
      let firstInvalid;
      Object.entries(fields || {}).forEach(([name, message]) => {
        const field = form.elements.namedItem(name);
        const error = form.querySelector(`[data-error-for="${CSS.escape(name)}"]`);
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          firstInvalid ||= field;
        }
        if (error) error.textContent = message;
      });
      const invalidStep = firstInvalid?.closest('[data-csc-rfp-step]');
      if (invalidStep) showStep(Number(invalidStep.dataset.cscRfpStep), false);
      firstInvalid?.focus();
    };

    resetRequestId();
    updateCompany();
    showStep(1, false);
    customerType.addEventListener('change', updateCompany);
    variantSelect?.addEventListener('change', updateVariant);
    next.addEventListener('click', () => {
      clearErrors();
      if (validateStep(steps[0])) showStep(2);
    });
    back.addEventListener('click', () => showStep(1));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearErrors();
      if (!form.reportValidity()) return;
      submit.disabled = true;
      submitLabel.textContent = root.dataset.sendingMessage;
      try {
        const payload = Object.fromEntries(new FormData(form));
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (!response.ok) {
          status.textContent = result?.error?.message || root.dataset.errorMessage;
          showFieldErrors(result?.fields);
          if (!result?.fields) status.focus();
          return;
        }
        status.textContent = root.dataset.successMessage.replace('[reference]', result.draftOrder.name);
        form.reset();
        updateCompany();
        updateVariant();
        resetRequestId();
        showStep(1, false);
        status.focus();
      } catch {
        status.textContent = root.dataset.errorMessage;
        status.focus();
      } finally {
        submit.disabled = false;
        submitLabel.textContent = originalSubmitLabel;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
